function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.004 7.853l5.36-5.362A1.07 1.07 0 008.852.98L4.248 5.585 1.825 3.162A1.07 1.07 0 00.313 4.674l3.179 3.18a1.065 1.065 0 001.512 0z",
  fill: "#fff"
});

var SvgIconWhiteChecked = function SvgIconWhiteChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 9",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDExIDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01LjAwMzc4IDcuODUzM0wxMC4zNjM4IDIuNDkxNUMxMC43ODI5IDIuMDczOTEgMTAuNzgxOSAxLjM5NyAxMC4zNjM4IDAuOTc5NDE2QzkuOTQ3MjcgMC41NjIzNjMgOS4yNjkzMiAwLjU2MjM2MyA4Ljg1MjI4IDAuOTc5NDE2TDQuMjQ3NzYgNS41ODUxOEwxLjgyNTIxIDMuMTYxOTlDMS40MDc2MyAyLjc0NDk0IDAuNzMwMjE2IDIuNzQ0OTQgMC4zMTMxNzkgMy4xNjE5OUMtMC4xMDQzOTMgMy41Nzk1OCAtMC4xMDQzOTMgNC4yNTc1NiAwLjMxMzE3OSA0LjY3NDA4TDMuNDkxNzUgNy44NTMzQzMuNzAwOCA4LjA2MjM2IDMuOTc0MDIgOC4xNjY2MyA0LjI0Nzc2IDguMTY2NjNDNC41MjE1MSA4LjE2NjYzIDQuNzk0NzIgOC4wNjIzNiA1LjAwMzc4IDcuODUzM1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgIconWhiteChecked as ReactComponent };